import { EMPTY_FIELD } from 'constants/emptyField';
import { Resources } from 'constants/resources';

import { usePermissions } from 'hooks/usePermissions';
import { useRecordModal } from 'hooks/useRecordModal';
import { MethodsDeleteDialog } from 'pages/Methods/components/MethodsDeleteDialog/MethodsDeleteDialog';
import { MethodsFilter } from 'pages/Methods/MethodsFilter';
import { CreateButton } from 'shared/mui/Buttons';
import {
  ContextMenu,
  ContextMenuDeleteButton,
  ContextMenuEditButton,
  ContextMenuEntityUserActionsButton,
  ContextMenuShowButton,
} from 'shared/mui/ContextMenu';
import {
  BooleanField,
  DateTimeField,
  EmbeddedFunctionField,
  FunctionField,
  TextField,
  TooltipTextField,
} from 'shared/react-admin/Fields';
import { TooltipTextLinkField } from 'shared/react-admin/Fields/TooltipTextLinkField/TooltipTextLinkField';
import { ListPage } from 'shared/react-admin/Pages';
import { MethodLogosShowDialog } from 'shared/widgets/MethodLogosShowDialog/MethodLogosShowDialog';
import { Method } from 'types/embedded/method';
import { MethodLogo } from 'types/embedded/methodLogo';
import { Permission } from 'types/embedded/permission';

import { DatagridStyled, ImageFieldStyled } from './MethodsList.styled';

export const MethodsList: React.FC = () => {
  const { hasResourceAccess, hasResourcePermissions } = usePermissions();
  const { record, handleOpenRecordModal, openRecordModal, handleCloseRecordModal } =
    useRecordModal<Method>();
  const {
    record: logo,
    handleCloseRecordModal: handleCloseRecordModalLogo,
    openRecordModal: openRecordModalLogo,
    handleOpenRecordModal: handleOpenRecordModalLogo,
  } = useRecordModal<MethodLogo>();

  return (
    <ListPage
      actions={[
        hasResourcePermissions(Resources.Methods, [Permission.Full, Permission.Create]) && (
          <CreateButton key="create-comissions" />
        ),
      ]}
      empty={false}
      headerTitle={{
        titleText: 'Методы',
        tooltipText:
          'Способ проведения платежа в Интернет, обладающий определенными характеристиками. Например, банковская карта, ваучер, криптовалютный кошелек.',
      }}
      sort={{ field: 'id', order: 'DESC' }}
    >
      <MethodsFilter />
      <DatagridStyled bulkActionButtons={false}>
        <TextField label="ID" sortBy="id" source="originId" />
        <TooltipTextLinkField
          label="Название метода"
          resource="methods"
          source="name"
          type="show"
        />
        <TooltipTextField label="Алиас" source="alias" />
        {hasResourceAccess('method_types') && (
          <EmbeddedFunctionField
            cellClassName="column-methodType"
            label="Тип метода"
            sortBy="methodType.name"
            sourceField="methodType.name"
          />
        )}
        <BooleanField label="Активен" source="active" />
        {hasResourceAccess(Resources.MethodLogos) && (
          <FunctionField
            emptyText={EMPTY_FIELD}
            label="Логотип"
            render={(record: Method) => (
              <ImageFieldStyled
                onClick={() => handleOpenRecordModalLogo(record?.logo)}
                source="logo.filePath"
              />
            )}
            source="logo"
          />
        )}
        <DateTimeField label="Дата создания" source="createdAt" />
        <DateTimeField label="Дата редактир." source="updatedAt" />
        <ContextMenu
          render={(record) => [
            hasResourceAccess(Resources.UserActions) && (
              <ContextMenuEntityUserActionsButton entityName="method" key="user-action-button" />
            ),
            <ContextMenuShowButton key="show-button" />,
            hasResourcePermissions(Resources.Methods, [Permission.Full, Permission.Update]) && (
              <ContextMenuEditButton key="edit-button" />
            ),
            hasResourcePermissions(Resources.Methods, [Permission.Full, Permission.Delete]) && (
              <ContextMenuDeleteButton
                key="delete-button"
                onClick={() => handleOpenRecordModal(record as Method)}
              />
            ),
          ]}
        />
      </DatagridStyled>
      {openRecordModal && (
        <MethodsDeleteDialog
          onClose={handleCloseRecordModal}
          open={openRecordModal}
          record={record}
        />
      )}
      {logo && (
        <MethodLogosShowDialog
          methodLogo={logo}
          onClose={handleCloseRecordModalLogo}
          open={openRecordModalLogo}
          sourceId="id"
        />
      )}
    </ListPage>
  );
};
